// User Lifecycle — shared password rule (mirrors backend services/password_policy.py).
export const PASSWORD_RULE_TEXT =
  "Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number and a symbol.";

export function passwordOk(pw) {
  const p = pw || "";
  return (
    p.length >= 8 &&
    /[A-Z]/.test(p) &&
    /[a-z]/.test(p) &&
    /[0-9]/.test(p) &&
    /[^A-Za-z0-9]/.test(p)
  );
}

// Returns an error message string, or null when valid.
export function validatePasswordPair(pw, pw2) {
  if (!passwordOk(pw)) return PASSWORD_RULE_TEXT;
  if (pw !== pw2) return "Passwords do not match";
  return null;
}
